import { GenericLazyString } from '@eventbrite/i18n';
import React, { useRef } from 'react';
import { useStickyHeader } from '../../hooks/dom/sticky';
import './CategoryBrowseHeader.scss';

export const CategoryBrowseStickyHeader = (props: {
    title?: string | GenericLazyString;
}) => {
    const { title } = props;
    const intersectionRef = useRef(null);
    const isSticky = useStickyHeader(intersectionRef);

    return (
        <>
            <div ref={intersectionRef} />
            <div
                className={`category-browse--header-mobile ${
                    isSticky
                        ? 'category-browse--header-mobile--sticky'
                        : 'eds-hide'
                }`}
            >
                <span className="eds-text-bl">{title}</span>
            </div>
        </>
    );
};

CategoryBrowseStickyHeader.defaultProps = {
    handleClick: () => {
        return;
    },
};
